import { render, staticRenderFns } from "./testButtons.vue?vue&type=template&id=3527eed2&"
import script from "./testButtons.vue?vue&type=script&lang=js&"
export * from "./testButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3527eed2')) {
      api.createRecord('3527eed2', component.options)
    } else {
      api.reload('3527eed2', component.options)
    }
    module.hot.accept("./testButtons.vue?vue&type=template&id=3527eed2&", function () {
      api.rerender('3527eed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/testButtons.vue"
export default component.exports